// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function header1_viewportLeave(event) {
	//Add your code for this event here: 

let fadeEffectOptions = {
 "duration": 500,
 "delay": 0,
 
}	

$w('#first').hide("fade",fadeEffectOptions)
$w('#grey').show("fade",fadeEffectOptions)


}

export function header1_viewportEnter(event) {
	//Add your code for this event here:

let fadeEffectOptions = {
 "duration": 500,
 "delay": 0,
 
}	


$w('#first').show("fade",fadeEffectOptions)
$w('#grey').hide("fade",fadeEffectOptions)	

}




export function mehiron_mouseIn(event) {
	//Add your code for this event here: 

$w('#mhiron').show()

}

export function mehiron2_mouseIn(event) {
	//Add your code for this event here: 

$w('#mhiron').show()


}

export function hoverBox17_mouseIn(event) {
	//Add your code for this event here:

$w('#mhiron').hide()
	

}

export function hoverBox9_mouseIn(event) {
	//Add your code for this event here: 

$w('#mhiron').hide()


}

export function hoverBox7_mouseIn(event) {
	//Add your code for this event here:

$w('#mhiron').hide()
$w('#sherutim').hide()

	

}

export function hoverBox15_mouseIn(event) {
	//Add your code for this event here: 

$w('#mhiron').hide()
$w('#sherutim').hide()



}

export function mhiron_mouseOut(event) {
	//Add your code for this event here:

$w('#mhiron').hide()
	

}

export function shirut2_mouseIn(event) {
	//Add your code for this event here: 

$w('#sherutim').show()


}

export function shirut_mouseIn(event) {
	//Add your code for this event here: 


$w('#sherutim').show()


}

export function sherutim_mouseOut(event) {
	//Add your code for this event here: 

$w('#sherutim').hide()


}

export function hoverBox5_mouseIn(event) {
	//Add your code for this event here: 

$w('#sherutim').hide()


}

export function hoverBox13_mouseIn(event) {
	//Add your code for this event here: 

$w('#sherutim').hide()


}

export function shirut_mouseIn_1(event) {
	//Add your code for this event here: 

$w('#sherutim').show()

}

export function mehiron2_mouseIn_1(event) {
	//Add your code for this event here:

$w('#mhiron').show()	

}

export function hoverBox15_mouseIn_1(event) {
	//Add your code for this event here:

$w('#mhiron').hide()
$w('#sherutim').hide()



}

export function hoverBox13_mouseIn_1(event) {
	//Add your code for this event here: 

$w('#sherutim').hide()


}

export function text227_mouseIn(event) {
	//Add your code for this event here: 

$w('#mhiron').hide()


}

export function first_mouseIn(event) {
	//Add your code for this event here: 


$w('#mhiron').hide()
$w('#sherutim').hide()

}


import wixWindow from 'wix-window';
$w.onReady(function () {
if (wixWindow.formFactor==="Mobile")
{
$w("#mobile").show();
}
});